
<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="mb-0 fw-bold">{{ 'ADMIN.USERS.TITLE' | translate }}</h1>
  
</div>
<!-- HideAfter -->
@if (errorMessage) {
<div class="alert alert-danger" HideAfter>
  <i class="bi-exclamation-circle mr-2"></i>
  {{ errorMessage }}
  <i class="bi-x" style="font-size: 2rem;"></i>
</div>
}
<table class="table table-hover table-striped rounded-3">
  <thead>
    <tr>
      <th scope="col">{{ 'COMMON.FULL_NAME' | translate }}</th>
      <th scope="col">{{ 'COMMON.EMAIL' | translate }}</th>
      <th scope="col">{{ 'COMMON.STATUS' | translate }}</th>
      <th scope="col">{{ 'ADMIN.USERS.IS_ADMIN' | translate }}</th>
      <th scope="col">{{ 'ADMIN.USERS.ROLE' | translate }}</th>
      <th scope="col">{{ 'COMMON.CREATED_AT' | translate }}</th>
      <th scope="col">{{ 'COMMON.UPDATED_AT' | translate }}</th>
      <th scope="col">{{ 'COMMON.ACTIONS' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (user of users$ |async; track user.public_id) {
    <tr>
      <td>
          {{ user.firstName }} {{ user.lastName }}
      </td>
      <td>
        {{user.email}}
      </td>
      <td>
        @if (user.is_active) { 
            <span class="badge bg-success me-1">{{ 'ADMIN.USERS.ACTIVE_USER' | translate }}</span>
        } @else {
            <span class="badge bg-danger me-1">{{ 'ADMIN.USERS.NON_ACTIVE_USER' | translate }}</span>
        }
      </td>
      <td>
        @if (user.is_admin) { 
            <i class="bi-check-lg text-success"></i>
        } @else {
            <i class="bi-x-lg text-danger"></i>
        }
      </td>
      <td>
        @for (role of user.application_roles; track $index) {
            <span class="badge bg-secondary me-1">{{ role.name }}</span>
        }
      </td>
      <td class="date-cell">
        <span
          class="d-inline-flex align-items-center small text-muted"
          [attr.title]="user.createdAt | date: 'dd MMM yyyy HH:mm'"
          
        >
          <i class="bi bi-calendar3 me-1"></i>
          {{ user.createdAt | date: 'dd MMM yyyy' }}
        </span>
      </td>
      <td class="date-cell">
        <span
          class="d-inline-flex align-items-center small text-muted"
          [attr.title]="user.updatedAt | date: 'dd MMM yyyy HH:mm'"
        >
          <i class="bi bi-calendar3 me-1"></i>
          {{ user.updatedAt | date: 'dd MMM yyyy' }}
        </span>
      </td>
      <td>
      </td>
    </tr>
  }  
  </tbody>
</table>

